import * as apiTo from '@/modular-api'

const initialState = () => ({
  contacts: null
})

export default {
  namespaced: true,

  state: initialState(),

  getters: {
    primaryContact: state => state.contacts.find(contact => contact.is_primary) || null
  },

  mutations: {
    setContacts: (state, payload) => (state.contacts = payload),
    resetState: state => Object.assign(state, initialState())
  },

  actions: {
    getAndSetContacts: ({ commit }, provider) => {
      const apiName = `GET_${provider.type.toUpperCase()}_CONTACTS`

      return apiTo[apiName](provider.id).then(({ data }) => commit('setContacts', data.result))
    },

    setPrimaryContact: ({ commit, state, dispatch }, { contactId, payload }) => {
      return apiTo.UPDATE_CONTACT(contactId, payload)
    }
  }
}
